/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finals_Finish_Hint_ReadyInputs */



/**
* | output |
* | --- |
* | "Finish finals and determine winner" |
*
* @param {Finals_Finish_Hint_ReadyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finals_finish_hint_ready = /** @type {((inputs?: Finals_Finish_Hint_ReadyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finals_Finish_Hint_ReadyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer la finale et déterminer le vainqueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalizar finales y determinar ganador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finalizar finais e determinar vencedor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Concludi le finali e determina il vincitore")
	return /** @type {LocalizedString} */ ("Finish finals and determine winner")
});